function size_validation(ele) {
  const max = parseInt(ele.getAttribute("max"), 10);
  const min = parseInt(ele.getAttribute("min"), 10);
  const value = parseInt(ele.value, 10);

  if (value > max) {
    ele.value = max;
  } else if (value < min) {
    ele.value = min;
  }

  // enablecart();
}
   
(function () {
  const measure = document.querySelector('.pdp-measure');
  const setName = document.getElementById('setname');
  if (!measure && !setName) return;

  const sizeFields = measure ? measure.querySelectorAll('.sizefields') : [];
  const MIN = 100;

  let maxWidth = 0;
  let maxHeight = 0;

  function parseSize(str) {
    if (!str) return;
    const parts = str.toLowerCase().split('x').map(s => parseInt(s, 10));
    if (parts.length !== 2 || parts.some(isNaN)) return;
    maxHeight = parts[0];
    maxWidth  = parts[1];

    sizeFields.forEach(el => {
      const limit = el.dataset.dim === 'width' ? maxWidth : maxHeight;
      el.setAttribute('max', limit);
      if (el.value !== '') validateSizeField(el);
    });
  }

  function getLimit(el) {
    return el.dataset.dim === 'width' ? maxWidth : maxHeight;
  }

  function getErrorWrap(el) {
    // Size fields sit inside .pdp-measure__field; setname sits inside .product-form__input
    return el.closest('.pdp-measure__field') || el.closest('.product-form__input') || el.parentElement;
  }

  function setError(el, msg) {
    el.classList.add('is-invalid');
    el.classList.remove('is-valid');
    const wrap = getErrorWrap(el);
    let err = wrap.querySelector('.pdp-measure__error');
    if (!err) {
      err = document.createElement('small');
      err.className = 'pdp-measure__error';
      err.style.cssText = 'color:#EB001B;display:block;margin-top:4px;';
      wrap.appendChild(err);
    }
    err.textContent = msg;
  }

  function clearError(el) {
    el.classList.remove('is-invalid');
    const err = getErrorWrap(el).querySelector('.pdp-measure__error');
    if (err) err.textContent = '';
  }

  function validateSizeField(el) {
    const val = el.value.trim();
    const dim = el.dataset.dim;
    const limit = getLimit(el);

    if (val === '') { setError(el, 'This field is required.'); return false; }
    const n = parseInt(val, 10);
    if (isNaN(n) || n < MIN) { setError(el, `Enter a valid ${dim} (min ${MIN}mm).`); return false; }
    if (limit && n > limit) { setError(el, `${dim} should be between 0 - ${limit}mm`); return false; }
    clearError(el);
    el.classList.add('is-valid');
    return true;
  }

  function validateSetName() {
    if (!setName) return true;
    const val = setName.value.trim();
    if (val === '') {
      setError(setName, 'Please enter a location (e.g. Bedroom).');
      return false;
    }
    if (val.length < 2) {
      setError(setName, 'Location must be at least 2 characters.');
      return false;
    }
    clearError(setName);
    setName.classList.add('is-valid');
    return true;
  }

  function validateAll() {
    let ok = true;
    sizeFields.forEach(el => { if (!validateSizeField(el)) ok = false; });
    if (!validateSetName()) ok = false;
    return ok;
  }

  // Per-field listeners — size fields
  sizeFields.forEach(el => {
    el.addEventListener('input', () => {
      if (el.value === '') { clearError(el); el.classList.remove('is-valid'); return; }
      validateSizeField(el);
    });
    el.addEventListener('blur', () => validateSizeField(el));
  });

  // Set Name listeners
  if (setName) {
    setName.addEventListener('input', () => {
      if (setName.value === '') { clearError(setName); setName.classList.remove('is-valid'); return; }
      validateSetName();
    });
    setName.addEventListener('blur', validateSetName);
  }

  // Variant change
  const sizeSelect = document.querySelector('select[name="options[Size]"]');
  if (sizeSelect) {
    parseSize(sizeSelect.value);
    sizeSelect.addEventListener('change', e => parseSize(e.target.value));
  }
  document.addEventListener('change', e => {
    if (e.target.matches?.('select[name="options[Size]"], input[name="options[Size]"]')) {
      parseSize(e.target.value);
    }
  });

  // Submit guard
  document.querySelectorAll('form[action$="/cart/add"]').forEach(form => {
    form.addEventListener('submit', e => {
      if (!validateAll()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const first = document.querySelector('.is-invalid');
        if (first) {
          first.scrollIntoView({ behavior: 'smooth', block: 'center' });
          first.focus({ preventScroll: true });
        }
      }
    }, true);
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  

  /* ---------- FAQ: only one open at a time (optional) ---------- */
  document.querySelectorAll('.pdp-faq__item').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      document.querySelectorAll('.pdp-faq__item').forEach(function (other) {
        if (other !== item) other.open = false;
      });
    });
  });

  /* ---------- Reviews carousel (basic scroll) ---------- */
 
    const slider = document.querySelector('.pdp-reviews__grid');
    const prevBtn = document.querySelector('[data-reviews-prev]');
    const nextBtn = document.querySelector('[data-reviews-next]');

    if(!slider) return;

    const updateButtons = ()=>{

        const max =
            slider.scrollWidth -
            slider.clientWidth;

        prevBtn.disabled =
            slider.scrollLeft <= 5;

        nextBtn.disabled =
            slider.scrollLeft >= max - 5;
    };


    const slideAmount = ()=>{
        const card =
            slider.querySelector('.pdp-review-card');

        return card.offsetWidth + 20; // gap
    }


    prevBtn.addEventListener('click',()=>{
        slider.scrollBy({
            left:-slideAmount(),
            behavior:'smooth'
        });
    });

    nextBtn.addEventListener('click',()=>{
        slider.scrollBy({
            left:slideAmount(),
            behavior:'smooth'
        });
    });


    slider.addEventListener('scroll',updateButtons);

    window.addEventListener('resize',updateButtons);

    updateButtons();


    /* touch swipe support */
    let startX = 0;
    let endX = 0;

    slider.addEventListener('touchstart',(e)=>{
        startX = e.touches[0].clientX;
    });

    slider.addEventListener('touchend',(e)=>{

        endX = e.changedTouches[0].clientX;

        let diff = startX - endX;

        if(Math.abs(diff) < 50) return;

        slider.scrollBy({
            left: diff > 0
                ? slideAmount()
                : -slideAmount(),
            behavior:'smooth'
        });

    });

    const nav = document.querySelector('.pdp-reviews__nav');
const head = document.querySelector('.pdp-reviews__head');

function moveNav() {
    if(window.innerWidth < 750){

        // move below slider
        slider.after(nav);

    } else {

        // move back into heading (desktop)
        head.appendChild(nav);
    }
}

window.addEventListener('resize', moveNav);
moveNav();
 
});